import { render, staticRenderFns } from "./DesktopReviews.vue?vue&type=template&id=03a5aff4&scoped=true&"
import script from "./DesktopReviews.vue?vue&type=script&lang=js&"
export * from "./DesktopReviews.vue?vue&type=script&lang=js&"
import style0 from "./DesktopReviews.vue?vue&type=style&index=0&id=03a5aff4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5aff4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CollectionReview: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/CollectionReview.vue').default})
